// @TODO [CX-663]: clean up this file when workspaces are removed

import { i18next as i18n } from '@hotjar/translations';
import { tokens } from '@hotjar/hotsauce';
import {
    getWidgetConfiguration,
    setWidgetConfiguration,
    updateWidgetConfiguration
} from '@hotjar/integrations/domains/slack/api';
import * as SlackFeature from '@hotjar/integrations/domains/slack/feature';
import * as MSTeamsFeature from '@hotjar/integrations/domains/ms-teams/feature';
import {
    getFeedbackSettings as getMsTeamsFeedbackSettings,
    saveFeedbackSettings as saveMsTeamsFeedbackSettings
} from '@hotjar/integrations/domains/ms-teams/api';
import {
    getFeedbackSettings as getWebhooksFeedbackSettings,
    saveFeedbackSettings as saveWebhooksFeedbackSettings
} from '@hotjar/integrations/domains/webhooks/api';
import * as gettingStartedGuide from '@hotjar/webapp/domains/activation/getting-started-guide';
import * as CONSTANTS from '@hotjar/insights-common/constants/legacy';
import { invalidateFeedbackSummaryCache } from '@hotjar/webapp/hooks/useFeedbackSummary';
import { invalidateFeedbackWidgets, invalidateFeedbackToolsCount } from '@hotjar/feedback';

// eslint-disable-next-line max-len
import { areStepsValid } from '@hotjar/feedback/components/IncomingFeedback/IncomingFeedbackWizard/Sections/Steps/StepsSection';
import { WebhooksFeature } from '@hotjar/integrations';
import { cloneDeep } from 'lodash-es';

angular.module('hjFeedbackModule').controller('FeedbackEditCreateCtrl', [
    '$q',
    '$rootScope',
    '$scope',
    '$state',
    '$stateParams',
    '$timeout',
    '$window',
    'ColorHelper',
    'DefaultFeedbackData',
    'Allowances',
    'AskFeature',
    'NextItemData',
    'Notify',
    'Restangular',
    'RestangularAsk',
    'restDefaultHandlers',
    'Site',
    'TargetingRule',
    'Track',
    'User',
    'UserData',
    function (
        $q,
        $rootScope,
        $scope,
        $state,
        $stateParams,
        $timeout,
        $window,
        ColorHelper,
        DefaultFeedbackData,
        Allowances,
        AskFeature,
        NextItemData,
        Notify,
        Restangular,
        RestangularAsk,
        restDefaultHandlers,
        Site,
        TargetingRule,
        Track,
        User,
        UserData
    ) {
        /*************************
         * PRIVATE VARIABLES
         *************************/
        const rSite = AskFeature.isAllowedForAsk('ask.separate_service')
            ? RestangularAsk.one('sites', $stateParams.siteId)
            : Restangular.one('sites', $stateParams.siteId);
        const rFeedbackWidgets = rSite.all('feedback');
        const rUserAttributes = Restangular.one('sites', $stateParams.siteId).one('attributes');
        const mode = $stateParams.feedbackWidgetId ? 'edit' : 'create';

        /*************************
         * SCOPE VARIABLES
         *************************/
        $scope.model = {
            flowSections: null,
            accentColorSetManually: false,
            defaultAccentColor: angular.copy(DefaultFeedbackData.getData().background),
            currentFeedbackWidget: {},
            feedbackWidgetsCount: null,
            forwarding_email_address_list: null,
            forwardingSettings: {},
            languageChoices: CONSTANTS.incomingFeedbackLanguageChoices,
            rtlLanguages: CONSTANTS.rtlLanguages,
            loaded: false,
            mode: mode,
            previewConfig: {},
            emotionStyleChoices: angular.copy(CONSTANTS.incomingEmotionStyleChoices),
            skinChoices: CONSTANTS.skinChoices,
            sectionOptions: {
                activePageTargetingOption: null,
                activeUserTargetingOption: 'all',
                changedEmotionStyle: false,
                emailFieldEnabled: true,
                commentFooterEnabled: false,
                emailForwardingEnabled: true
            },
            siteId: $stateParams.siteId,
            userAttributes: []
        };

        $scope.i18n = i18n;

        Object.defineProperty($scope.model, 'feedbackId', {
            get() {
                return $scope.model.currentFeedbackWidget?.id ?? null;
            }
        });

        /*************************
         * ACCESS FUNCTIONS
         * These should remain functions, painful as it may be, so that on upsell they get re-checked in a digest().
         *************************/
        $scope.canUseEmotionStyleChoices = function () {
            return AskFeature.isAllowedForAsk('feedback.emotion_style_choices');
        };

        $scope.canUseUserAttributes = function () {
            return AskFeature.isAllowedForAsk('user_attributes.toggle');
        };

        $scope.canUseSlackIntegration = function () {
            return AskFeature.isAllowedForAsk(SlackFeature.FEATURE_NAME);
        };

        $scope.canUseMsTeamsIntegration = async function () {
            // Site is in the minimal plan (business)
            return await Allowances.isGateOpen(MSTeamsFeature.GATE_FEEDBACK, {
                id: $stateParams.siteId,
                type: 'site'
            });
        };

        $scope.canUseWebhooksIntegration = async function () {
            // Site is in the minimal plan (scale) and FF allowed
            const isGateOpen = await Allowances.isGateOpen(WebhooksFeature.GATE_FEEDBACK, {
                id: $stateParams.siteId,
                type: 'site'
            });

            const isAllowed = AskFeature.isAllowedForAsk(WebhooksFeature.FEATURE_NAME);

            return isGateOpen && isAllowed;
        };

        $scope.canUseAccentColorCustomization = function () {
            return AskFeature.isAllowedForAsk('feedback.appearance.accent_color');
        };

        /*************************
         * INITIALIZATION
         *************************/
        if ($scope.model.mode === 'create') {
            const toolCreatedFrom = $stateParams.copyId ? 'duplicate' : 'new';
            const customFeedbackData = NextItemData.get('feedback');
            let data = null;

            if (customFeedbackData && customFeedbackData.originator) {
                data = {
                    state_event_was_triggered_on: customFeedbackData.originator.state,
                    url_event_was_triggered_on: customFeedbackData.originator.url
                };
            }

            Track.toolCreationStarted('Incoming Feedback', toolCreatedFrom, data);
        }

        var widgetId = $stateParams.feedbackWidgetId || $stateParams.copyId,
            promises = {
                feedbackWidgetsCount: rSite.one('feedback').one('count').get(),
                seasonalEmotionStyles: rSite.one('feedback').one('styles').get()
            };

        if (widgetId) {
            promises.feedbackWidget = rSite.one('feedback', widgetId).get();

            initForwardingForExistingWidget(widgetId);
        } else {
            initForwardingForNewWidget();
        }

        if ($scope.canUseUserAttributes()) {
            rUserAttributes.get().then(function (res) {
                $scope.model.userAttributes = res.attributes;
            }, restDefaultHandlers.onError);
        }

        // Wait for all requests to return something, then load page accordingly.
        $q.all(promises).then(
            function (result) {
                $scope.model.feedbackWidgetsCount = result.feedbackWidgetsCount.count;
                setFlowSections();

                if (!$stateParams.feedbackWidgetId && !$stateParams.copyId) {
                    // Create a new feedback widget.
                    setNewFeedbackWidgetData();
                    onFeedbackWidgetModelLoad();
                    Track.browse('Incoming Feedback Start');
                    return;
                }

                // Load the existing widget in place or set null, either for editing or for creating by copy.
                $scope.model.currentFeedbackWidget = result.feedbackWidget;

                // Old widget configurations may be missing the widget_label setting so we make sure it is set
                $scope.model.currentFeedbackWidget.widget_label ??= null;

                // Old widget configurations may be missing the display_type setting so we make sure it is set
                $scope.model.currentFeedbackWidget.display_type ??= 'button';

                $scope.model.forwarding_email_address_list =
                    result.feedbackWidget.forwarding_email_address_list.join(', ');

                $scope.model.forwardingSettings.email = {
                    emails: result.feedbackWidget.forwarding_email_address_list,
                    enabled: result.feedbackWidget.forwarding_email_address_list.length > 0,
                    valid: true,
                    dirty: false
                };

                if ($scope)
                    if ($stateParams.copyId) {
                        var copyText = ' - COPY';

                        // Make sure the name is not longer than 50 characters (limit).
                        $scope.model.currentFeedbackWidget.name = _.trunc($scope.model.currentFeedbackWidget.name, {
                            length: 50 - copyText.length,
                            omission: ''
                        });

                        $scope.model.currentFeedbackWidget.name += copyText;
                        $scope.model.currentFeedbackWidget.enabled = false;
                        $scope.model.currentFeedbackWidget.response_count = 0;

                        $scope.form.$setDirty();
                    }

                applyEditChanges();
                onFeedbackWidgetModelLoad();
            },
            function (res) {
                restDefaultHandlers.onError(res);
            }
        );

        /*************************
         * PRIVATE FUNCTIONS
         *************************/

        /**
         * Returns a string with the name of the active forwarding methods:
         * e.g. Slack, Microsoft Teams, Email, and Webhooks.
         */
        function getActiveForwardingNames() {
            const forwarding = {
                slack: i18n.t('feedback:wizard.section.integrations.slack'),
                msTeams: i18n.t('feedback:wizard.section.integrations.ms-teams'),
                email: i18n.t('feedback:wizard.section.integrations.email'),
                webhooks: i18n.t('feedback:wizard.section.integrations.webhooks')
            };

            return Object.keys(forwarding)
                .filter((key) => $scope.enabledAndValid($scope.model.forwardingSettings[key]))
                .map((key) => forwarding[key])
                .join(', ');
        }

        /**
         * Initialises forwarding settings (Slack, Microsoft Teams, Email)
         * for new feedback widgets.
         */
        function initForwardingForNewWidget() {
            $scope.model.forwardingSettings.slack = {
                enabled: false,
                channels: [],
                valid: true,
                dirty: false,
                isConnected: false
            };
            $scope.model.forwardingSettings.email = {
                enabled: false,
                emails: [],
                valid: true,
                dirty: false
            };
            $scope.model.forwardingSettings.msTeams = {
                enabled: false,
                webhooks: [],
                connected: false,
                valid: false,
                dirty: false
            };
            $scope.model.forwardingSettings.webhooks = {
                enabled: false,
                webhooks: [],
                valid: false,
                dirty: false
            };
        }

        /**
         * Initialises forwarding settings (Slack, Microsoft Teams, and Webhooks)
         * for existing feedback widgets.
         */
        function initForwardingForExistingWidget(widgetId) {
            initSlackForwardingForExistingWidget(widgetId);
            initMsTeamsForwardingForExistingWidget(widgetId);
            initWebhooksForwardingForExistingWidget(widgetId);
        }

        /**
         * Initialises Slack settings for existing feedback widgets.
         */
        function initSlackForwardingForExistingWidget(widgetId) {
            if ($scope.canUseSlackIntegration()) {
                getWidgetConfiguration($stateParams.siteId, 'incoming_feedback', widgetId)
                    .then(({ data }) => {
                        $timeout(() => {
                            $scope.model.forwardingSettings.slack = {
                                channels: data.channels || [],
                                enabled: data.enabled,
                                valid: true,
                                dirty: false,
                                isConnected: false
                            };
                        });
                    })
                    .catch(() => {
                        $timeout(() => {
                            $scope.model.forwardingSettings.slack = {
                                enabled: false,
                                channels: [],
                                valid: true,
                                dirty: false,
                                isConnected: false
                            };
                        });
                    });
            } else {
                $scope.model.forwardingSettings.slack = {
                    enabled: false,
                    channels: [],
                    valid: true,
                    dirty: false,
                    isConnected: false
                };
            }
        }

        /**
         * Initialises Microsoft Teams settings for existing feedback widgets.
         */
        function initMsTeamsForwardingForExistingWidget(widgetId) {
            const baseMsTeamsSettings = {
                enabled: false,
                webhooks: [],
                connected: false,
                valid: false,
                dirty: false
            };
            $scope.canUseMsTeamsIntegration().then((canUse) => {
                if (!canUse) {
                    // Site not in minimal plan
                    $scope.model.forwardingSettings.msTeams = {
                        ...baseMsTeamsSettings
                    };
                    return;
                }
                // Feature available for the site
                getMsTeamsFeedbackSettings($stateParams.siteId, widgetId)
                    .then((data) => {
                        $timeout(() => {
                            $scope.model.forwardingSettings.msTeams = {
                                ...baseMsTeamsSettings,
                                enabled: data.enabled,
                                webhooks: data.webhooks || [],
                                valid: data.webhooks?.length > 0
                            };
                        });
                    })
                    .catch(() => {
                        $timeout(() => {
                            $scope.model.forwardingSettings.msTeams = {
                                ...baseMsTeamsSettings
                            };
                        });
                    });
            });
        }

        /**
         * Initialises Webhooks settings for existing feedback widgets.
         */
        function initWebhooksForwardingForExistingWidget(widgetId) {
            const baseSettings = {
                enabled: false,
                webhooks: [],
                valid: false,
                dirty: false
            };
            $scope.canUseWebhooksIntegration().then((canUse) => {
                if (!canUse) {
                    // Site not in minimal plan
                    $scope.model.forwardingSettings.webhooks = baseSettings;
                    return;
                }
                // Feature available for the site
                getWebhooksFeedbackSettings($stateParams.siteId, widgetId)
                    .then((data) => {
                        $timeout(() => {
                            $scope.model.forwardingSettings.webhooks = {
                                ...baseSettings,
                                enabled: data.enabled,
                                webhooks: data.webhooks || [],
                                valid: data.webhooks?.length > 0
                            };
                        });
                    })
                    .catch(() => {
                        $timeout(() => {
                            $scope.model.forwardingSettings.webhooks = baseSettings;
                        });
                    });
            });
        }

        /**
         * Returns true if the embeddable widgets flag is active or display_type is inline
         */
        function showTypeSection() {
            return (
                AskFeature.isAllowedForAsk('feedback.embeddable_widget') ||
                $scope.model.currentFeedbackWidget.display_type === 'inline'
            );
        }

        /**
         * Set the flow sections in the model. This is dependent on the total widgets count, and therefore has to be
         * carried out after this value has been retrieved.
         */
        function setFlowSections() {
            $scope.model.flowSections = {
                name: {
                    open: true,
                    openedOnce: true,
                    success: null,
                    stepNumber: generateStepNumber(mode, 1),
                    hide: hideNameSection(mode)
                },
                type: {
                    open: showTypeSection() && hideNameSection(mode),
                    openedOnce: false,
                    success: null,
                    stepNumber: generateStepNumber(mode, 2),
                    hide: !showTypeSection()
                },
                appearance: {
                    open: !showTypeSection() && hideNameSection(mode),
                    openedOnce: false,
                    success: null,
                    stepNumber: generateStepNumber(mode, 3)
                },
                questions: {
                    open: false,
                    openedOnce: false,
                    success: null,
                    stepNumber: generateStepNumber(mode, 4)
                },
                targeting: {
                    open: false,
                    openedOnce: false,
                    success: null,
                    stepNumber: generateStepNumber(mode, 5)
                },
                forwarding: {
                    open: false,
                    openedOnce: false,
                    success: null,
                    stepNumber: generateStepNumber(mode, 6),
                    getActiveForwardingNames: getActiveForwardingNames
                },
                review: {
                    open: false,
                    openedOnce: false,
                    success: true,
                    stepNumber: generateStepNumber(mode, 7)
                }
            };
            $timeout(() => {
                if ($scope.model.flowSections.appearance.open || $scope.model.flowSections.review.open) {
                    $scope.reloadPreview();
                }
            });
        }

        /***
         * Get the step number for the flow sections. If the "details" or "type" sections are hidden
         * the step number of the following sections should reflect that. The "details" section is
         * set to always return one to not be offset when "type" is hidden
         *
         * @param mode - Whether we're in edit or create mode.
         * @param step - The actual step.
         * @returns number - recalculated step number, based on the number of hidden steps
         */
        function generateStepNumber(mode, step) {
            if (step === 1) return 1;
            let offsetSteps = 0;
            if (hideNameSection(mode)) offsetSteps++;
            if (!showTypeSection()) offsetSteps++;
            return step - offsetSteps;
        }

        /**
         * In CREATE mode, the name section should be hidden if there exist no other widgets created for the site.
         * In EDIT mode, the name section should be hidden if there is just one feedback widget.
         *
         * @param mode - The mode, whether it is 'create' or 'edit'.
         * @returns {boolean} True if the name section should be hidden, false otherwise.
         */
        function hideNameSection(mode) {
            if (mode === 'create') {
                return $scope.model.feedbackWidgetsCount === 0;
            } else if (mode === 'edit') {
                return $scope.model.feedbackWidgetsCount === 1;
            }
        }

        /**
         * Set the data for a new feedback widget.
         */
        function setNewFeedbackWidgetData() {
            var customFeedbackWidgetData = NextItemData.get('feedback');

            if (customFeedbackWidgetData && customFeedbackWidgetData.feedbackData) {
                $scope.model.currentFeedbackWidget = customFeedbackWidgetData.feedbackData;
                NextItemData.clear('feedback');
                applyCustomDataChanges();
            } else {
                $scope.model.currentFeedbackWidget = _.cloneDeep(
                    DefaultFeedbackData.getData($scope.model.feedbackWidgetsCount)
                );
            }
        }

        /**
         * Apply changes needed when the feedback model is loaded.
         */
        function onFeedbackWidgetModelLoad() {
            $scope.model.loaded = true;
            // reload sections to show/hide them depending on the model's just loaded values
            setFlowSections();
        }

        function isEmbedded() {
            return $scope.model.currentFeedbackWidget.display_type === 'inline';
        }

        function isParentSelectorInvalid(selector) {
            return isEmbedded() && (!selector || selector.length > 400);
        }

        /**
         * Apply changes needed when the feedback model is loaded.
         * Note: Used when editing.
         */
        function applyEditChanges() {
            if ($scope.model.currentFeedbackWidget.content.email === false) {
                $scope.model.sectionOptions.emailFieldEnabled = false;
            }

            if ($scope.model.currentFeedbackWidget.content.comment_footer) {
                $scope.model.sectionOptions.commentFooterEnabled = true;
            }

            var forwarding_email_address_list = $scope.model.currentFeedbackWidget.forwarding_email_address_list;

            // Address list is set to an empty string when checkbox is toggled.
            var isForwardingEmailAddressListEmpty =
                forwarding_email_address_list === null ||
                // When feedback is created through widget email addresses are set to [].
                !forwarding_email_address_list.length ||
                // When feedback is created through page, first element is an empty string.
                (forwarding_email_address_list.length === 1 && forwarding_email_address_list[0].length === 0);

            if (isForwardingEmailAddressListEmpty) {
                $scope.model.sectionOptions.emailForwardingEnabled = false;
            }

            $scope.model.sectionOptions.activePageTargetingOption = isTargetingAllPages() ? 'all' : 'specific';

            $scope.model.sectionOptions.activeUserTargetingOption = !hasAttributeRules() ? 'all' : 'specific';

            _.each($scope.model.flowSections, function (item) {
                item.open = false;
                item.openedOnce = true;
                item.success = true;
            });

            // When editing, open the review step unless some other is specified in URL
            const sectionToOpen = $scope.model.flowSections[$stateParams.activeFlowSection];
            if (sectionToOpen) {
                sectionToOpen.open = true;

                // Remove active section name from URL to prevent screen reloads
                // when stepping through history (ex. back button)
                $state.go('.', { activeFlowSection: null }, { reload: false, notify: false, location: 'replace' });
            } else {
                $scope.model.flowSections.review.open = true;
            }

            $scope.isQuestionsFormValid = areStepsValid({
                invitationMessage: $scope.model.currentFeedbackWidget.content.initial,
                mainQuestion: $scope.model.currentFeedbackWidget.content.emotion,
                emailRequest: $scope.model.currentFeedbackWidget.content.email,
                showEmailRequest: $scope.model.sectionOptions.emailFieldEnabled,
                showAdditionalMessage: $scope.model.sectionOptions.commentFooterEnabled,
                additionalMessage: $scope.model.currentFeedbackWidget.content.comment_footer,
                thankyouMessage: $scope.model.currentFeedbackWidget.content.thankyou,
                showLegal: $scope.model.currentFeedbackWidget.show_legal,
                siteHasLegalDetails: $scope.siteHasLegalDetails()
            });

            _.each($scope.model.flowSections, function (sec, name) {
                $scope.updateSuccessStatus(name);
            });
        }

        /**
         * This widget is created as new, using custom data.
         */
        function applyCustomDataChanges() {
            applyEditChanges();
        }

        /**
         * Check if this widget is targeting all pages.
         */
        function isTargetingAllPages() {
            return _.find($scope.model.currentFeedbackWidget.targeting, function (rule) {
                return rule.component === 'url' && rule.match_operation === 'contains' && rule.pattern === '/';
            });
        }

        /**
         * Check if this widget is targeting all users.
         */
        function isTargetingAllUsers() {
            return $scope.model.sectionOptions.activeUserTargetingOption === 'all';
        }

        /**
         * Check if we have at least 1 user attribute rule.
         */
        function hasAttributeRules() {
            return _.find($scope.model.currentFeedbackWidget.targeting, function (rule) {
                return rule.component === 'attribute';
            });
        }

        function saveSlackSettings(isEdit, widgetId) {
            if (!$scope.canUseSlackIntegration() || !$scope.model.forwardingSettings.slack.isConnected) {
                return;
            }

            const apiFunction = isEdit ? updateWidgetConfiguration : setWidgetConfiguration;

            return apiFunction($stateParams.siteId, 'incoming_feedback', widgetId, {
                enabled: $scope.model.forwardingSettings.slack.enabled,
                channels: $scope.model.forwardingSettings.slack.channels
            });
        }

        function saveMsTeamsSettings(widgetId) {
            return $scope.canUseMsTeamsIntegration().then((canUse) => {
                if (!canUse) {
                    return;
                }

                return saveMsTeamsFeedbackSettings($stateParams.siteId, widgetId, {
                    enabled: $scope.model.forwardingSettings.msTeams.enabled,
                    webhooks: $scope.model.forwardingSettings.msTeams.webhooks || []
                });
            });
        }

        function saveWebhooksSettings(widgetId) {
            return $scope.canUseWebhooksIntegration().then((canUse) => {
                if (!canUse) {
                    return;
                }

                return saveWebhooksFeedbackSettings($stateParams.siteId, widgetId, {
                    enabled: $scope.model.forwardingSettings.webhooks.enabled,
                    webhooks: $scope.model.forwardingSettings.webhooks.webhooks || []
                });
            });
        }

        function handleSettingsSave({ promise, callback, isEdit, widgetId = null }) {
            return promise
                .finally(() => {
                    // The finally is before the callback to ensure the queries get invalidated
                    // before the callback can use them

                    // TODO these invalidations should be part of a widget create/update mutation
                    invalidateFeedbackSummaryCache();
                    invalidateFeedbackWidgets(Number($scope.model.siteId));
                    invalidateFeedbackToolsCount(Number($scope.model.siteId), 'feedback');
                })
                .then((response) => {
                    if (response.success) {
                        if (!isEdit) {
                            widgetId = response.feedback_widget_id;
                        }

                        return $q.all([
                            saveSlackSettings(isEdit, widgetId),
                            saveMsTeamsSettings(widgetId),
                            saveWebhooksSettings(widgetId)
                        ]);
                    }

                    callback(response);
                    return $q.reject(response);
                }, restDefaultHandlers.onError)
                .then(
                    () => ({ success: true, widgetId: widgetId }),
                    (response) => {
                        if (response.error) {
                            return response;
                        }
                        $scope.toggleSection('forwarding');
                        return { error: 'Unable to save forwarding settings' };
                    }
                )
                .then(callback)
                .catch(restDefaultHandlers.onError);
        }

        function saveFeedbackWidget(callback) {
            var currentFeedbackWidget = $scope.model.currentFeedbackWidget,
                deferred = $q.defer(),
                validForm = $scope.allSectionsValid();

            // If the form is not valid, we have to return a promise manually.
            // Otherwise, return the restangular call which returns a promise automatically after it has completed.
            if (!validForm) {
                Notify.error('Save failed. Some details are invalid.');
                deferred.reject();
                return deferred.promise;
            }

            if ($scope.model.forwardingSettings.email.enabled) {
                currentFeedbackWidget.forwarding_email_address_list = _.uniq(
                    $scope.model.forwardingSettings.email.emails
                );
            } else {
                currentFeedbackWidget.forwarding_email_address_list = [];
            }

            if (isTargetingAllPages()) {
                currentFeedbackWidget.targeting = _.reject(currentFeedbackWidget.targeting, function (rule) {
                    return rule.component === 'url' && !(rule.match_operation === 'contains' && rule.pattern === '/');
                });
            }

            // If we are targeting all users, reject all attribute rules.
            if (isTargetingAllUsers()) {
                currentFeedbackWidget.targeting = _.reject(currentFeedbackWidget.targeting, function (rule) {
                    return rule.component === 'attribute';
                });
            }

            if ($scope.model.mode === 'edit') {
                // Feedback Widget already exists, update it.
                const promise = rSite.one('feedback', currentFeedbackWidget.id).customPUT(currentFeedbackWidget);

                return handleSettingsSave({
                    promise,
                    callback,
                    isEdit: true,
                    widgetId: currentFeedbackWidget.id
                });
            } else {
                Track.create('Incoming Feedback');
                gettingStartedGuide.markIncomingFeedbackAsCompleted(UserData.currentSite, User.get().id);

                const additionalHeaders = {};
                const promise = rFeedbackWidgets.post(currentFeedbackWidget, null, additionalHeaders);
                return handleSettingsSave({
                    promise,
                    callback,
                    isEdit: false
                });
            }
        }

        /**
         * Validate all page targeting rules (using the url component).
         *
         * @param updateRulesInModel Set to true if we with to update the targeting object
         *                           within the model. If false, a copy is used instead –
         *                           This is done so that the rules are not normalized
         *                           as the user is typing in fields.
         */
        function validatePageTargetingRules(updateRulesInModel) {
            var allValid = true,
                rules;

            // To not frustrate users. If they select 'all site' we do not remove/validate
            // any rules they already had. This avoids them loosing any rules they entered.
            // We will then, reject all the 'extra' targeting rules when saving.
            if ($scope.model.sectionOptions.activePageTargetingOption !== 'all') {
                rules = updateRulesInModel
                    ? $scope.model.currentFeedbackWidget.targeting
                    : angular.copy($scope.model.currentFeedbackWidget.targeting);

                _.each(rules, function (rule) {
                    if (_.includes(['trigger', 'url'], rule.component)) {
                        TargetingRule.validateAndNormalize(rule);
                        if (rule.error) {
                            allValid = false;
                        }
                    }
                });
            }

            return allValid;
        }

        /**
         * Close a section.
         *
         * @param sectionName Name of section we want to close.
         */
        function closeSection(sectionName) {
            $scope.model.flowSections[sectionName].open = false;
        }

        /**
         * Open the "next" section.
         *
         * @param sectionName Name of section we want to open next.
         */
        function openNextSection(sectionName) {
            var section = $scope.model.flowSections[sectionName];

            // Only open the "next" section if it has never been opened before.
            if (!section.open && !section.openedOnce) {
                $scope.openSection(sectionName);
            } else {
                $scope.openSection('review');
            }
        }

        /**
         * Scroll to a section.
         *
         * @sectionName Name of section to scroll to.
         */
        function scrollToSection(sectionName) {
            var contentOffset,
                elementOffset,
                window = angular.element($window);

            // We use timeout:0 so the positions are always taken at the end of the digest cycle.
            $timeout(function () {
                contentOffset = $('#content-inner').offset().top;
                elementOffset = $('#section-' + sectionName).offset().top;

                // Only scroll if the user is past a certain point.
                if (window.scrollTop() > 100) {
                    $('html, body').scrollTop(elementOffset - contentOffset - 15);
                }
            }, 0);
        }

        /**
         * Set the form as dirty, call a callback, and the reload the survey preview.
         *
         * @param callback Callback function to execute in the middle.
         */
        function setDirtyAndReloadPreview(callback, step) {
            $scope.form.$setDirty();
            if (callback) {
                callback();
            }
            $scope.reloadPreview(step);
        }

        /**
         * Validate name section.
         */
        function validateNameSection() {
            return $scope.model.currentFeedbackWidget.name;
        }

        function validateAppearanceSection() {
            return (
                (AskFeature.isAllowedForAsk('feedback.appearance.widget_label') ||
                    $scope.model.currentFeedbackWidget.widget_label === null) &&
                !isParentSelectorInvalid($scope.model.currentFeedbackWidget.parent_element_selector)
            );
        }

        /**
         * Validate questions section.
         */
        function validateQuestionsSection() {
            return $scope.isQuestionsFormValid;
        }

        /*************************
         * SCOPE FUNCTIONS
         *************************/
        $scope.highlightReviewSection = () => {
            //$scope.$apply ensures that the section is expanded before the scroll is attempted
            $scope.$apply(() => {
                $scope.openSection('review');
            });

            const reviewSection = document.querySelector('#section-review');

            if (reviewSection === null) return;
            reviewSection.scrollIntoView(true);

            const keyframes = [
                { boxShadow: `0 0 1px -5px ${tokens.color.primary_cta}` },
                { boxShadow: `0 0 1px 5px ${tokens.color.primary_cta}`, offset: 0.5 },
                { boxShadow: `0 0 1px -5px ${tokens.color.primary_cta}`, offset: 1 }
            ];

            const timings = { duration: 1000, iterations: 1 };

            reviewSection.animate(keyframes, timings);
        };

        /**
         * Save the feedback widget.
         */
        $scope.saveFeedbackWidget = function (changeState = true) {
            $scope.model.saveInProgress = true;

            return saveFeedbackWidget(function (res) {
                $scope.model.saveInProgress = false;

                if (res.success) {
                    $scope.form.$setPristine();
                    Notify.success('Feedback saved');

                    $scope.model.forwardingSettings.email.dirty = false;
                    $scope.model.forwardingSettings.slack.dirty = false;
                    $scope.model.forwardingSettings.msTeams.dirty = false;
                    $scope.model.forwardingSettings.webhooks.dirty = false;

                    if (changeState) {
                        $state.go('feedback.responses', {
                            siteId: UserData.currentSite.id,
                            feedbackWidgetId: res.widgetId ?? $scope.model.feedbackWidgetId,
                            newToolCreated: $scope.model.mode === 'create'
                        });
                    }
                } else {
                    Notify.error(res.error);
                }
            }).then(
                () => {
                    $scope.model.saveInProgress = false;
                },
                () => {
                    $scope.model.saveInProgress = false;
                }
            );
        };

        $scope.onStatusChange = function (status) {
            $scope.model.currentFeedbackWidget.enabled = status;
        };

        $scope.onWidgetLabelChange = function (widgetLabel) {
            $scope.$apply(function () {
                $scope.model.currentFeedbackWidget.widget_label = widgetLabel ? widgetLabel : null;
                $scope.reloadPreview();
            });
        };

        /**
         * Returns true if a specific section validates properly.
         * NOTE: This function validates the section as well.
         *
         * @param sectionName Name of section to check.
         * @param calledFromTemplate If true, it means the function was called from a template.
         */
        $scope.isSectionValid = function (sectionName, calledFromTemplate) {
            var valid = false;

            if (!$scope.model.currentFeedbackWidget) {
                return;
            }

            switch (sectionName) {
                case 'name':
                    valid = validateNameSection();
                    break;
                case 'appearance':
                    valid = validateAppearanceSection();
                    break;
                case 'targeting':
                    valid = $scope.validateTargetingSection(!calledFromTemplate);
                    break;
                case 'questions':
                    valid = validateQuestionsSection();
                    break;
                case 'forwarding':
                    valid = $scope.validateForwardingSection();
                    break;
                default:
                    valid = true;
                    break;
            }

            return Boolean(valid);
        };

        /**
         * Validate a section and update it's success status.
         * @param sectionName Name of section to validate.
         */
        $scope.updateSuccessStatus = function (sectionName) {
            var section = $scope.model.flowSections[sectionName];

            if (!$scope.model.currentFeedbackWidget) {
                return;
            }

            section.success = $scope.isSectionValid(sectionName);
            return section.success;
        };

        /**
         * Return true if all sections validate properly.
         */
        $scope.allSectionsValid = function () {
            if (!$scope.model.currentFeedbackWidget) {
                return;
            }

            return (
                validateNameSection() &&
                validateAppearanceSection() &&
                validateQuestionsSection() &&
                $scope.validateTargetingSection() &&
                $scope.validateForwardingSection()
            );
        };

        /**
         * Validate targeting section.
         *
         * @param updateRulesInModel Check validatePageTargetingRules().
         */
        $scope.validateTargetingSection = function (updateRulesInModel) {
            return (
                $scope.deviceTargetingRules().length > 0 &&
                $scope.model.sectionOptions.activePageTargetingOption &&
                validatePageTargetingRules(updateRulesInModel)
            );
        };

        /**
         * Validate email forwarding section.
         */
        $scope.validateForwardingSection = function () {
            const options = [
                $scope.model.forwardingSettings.email,
                $scope.model.forwardingSettings.slack,
                $scope.model.forwardingSettings.msTeams,
                $scope.model.forwardingSettings.webhooks
            ];

            // While we still waiting for the api responses, we mark the section as valid.
            if (!$scope.model.forwardingSettings || options.some((option) => !option)) {
                return true;
            }

            // option can be considered valid in two cases, either disabled or enabled and valid.
            return options.every((option) => !option.enabled || option.valid);
        };

        /**
         * Return a list which includes all positive page targeting rules.
         */
        $scope.positivePageTargetingRules = function () {
            if ($scope.model.currentFeedbackWidget) {
                return _.filter($scope.model.currentFeedbackWidget.targeting, function (r) {
                    return _.includes(['url', 'trigger'], r.component) && r.negate === false;
                });
            }
        };

        /**
         * Return a list which includes all negative page targeting rules.
         * NOTE: Negative rules can only be 'url' component types.
         */
        $scope.negativePageTargetingRules = function () {
            if ($scope.model.currentFeedbackWidget) {
                return _.filter($scope.model.currentFeedbackWidget.targeting, function (r) {
                    return r.component === 'url' && r.negate === true;
                });
            }
        };

        /**
         * Return a list which includes all device targeting rules.
         * NOTE: Negative rules can only be 'url' component types.
         */
        $scope.deviceTargetingRules = function () {
            if ($scope.model.currentFeedbackWidget) {
                return _.filter($scope.model.currentFeedbackWidget.targeting, function (r) {
                    return r.component === 'device';
                });
            }
        };

        function setForwardingDirty() {
            ['slack', 'email', 'msTeams', 'webhooks'].forEach((forward) => {
                if ($scope.model.forwardingSettings[forward]) {
                    // We have to create a new object otherwise the Forward component won't re-render
                    $scope.model.forwardingSettings[forward] = {
                        ...$scope.model.forwardingSettings[forward],
                        dirty: $scope.model.forwardingSettings[forward].enabled
                    };
                }
            });
        }
        /**
         * Toggle a section.
         *
         * @param sectionName Name of section to toggle.
         * @param nextSectionName Name of next section we would like to open.
         */
        $scope.toggleSection = function (sectionName, nextSectionName) {
            var section = $scope.model.flowSections[sectionName];

            if (section.open) {
                // Close and validate if it's currently open.
                closeSection(sectionName);
                $scope.updateSuccessStatus(sectionName);

                // If a next section is defined, open it.
                if (nextSectionName) {
                    openNextSection(nextSectionName);
                }

                if (sectionName === 'forwarding') {
                    setForwardingDirty();
                }
            } else {
                // Open it and close the others if it's currently closed.
                _.each($scope.model.flowSections, function (sec, name) {
                    if (name === sectionName) {
                        $scope.openSection(name);
                    } else if (sec.open) {
                        if (name === 'forwarding') {
                            setForwardingDirty();
                        }
                        closeSection(name);
                        $scope.updateSuccessStatus(name);
                    } else if (sectionName === 'review') {
                        // when opening review step, make sure all other sections are re-validated
                        $scope.updateSuccessStatus(name);
                    }
                });
            }

            scrollToSection(sectionName);
        };

        /**
         * Open a section.
         *
         * @param sectionName Name of section we want to open.
         */
        $scope.openSection = function (sectionName) {
            var section = $scope.model.flowSections[sectionName];

            section.open = true;
            section.openedOnce = true;

            // Reset the preview if we opened the appearance section.
            if (sectionName === 'appearance' || sectionName === 'review') {
                $scope.reloadPreview();
            }

            // Reset the preview in emotion state if we opened the questions section.
            if (sectionName === 'questions') {
                $scope.reloadPreview('emotion');
            }

            // Tag the recording if the user can see the nifty new user attribute targeting.
            if (sectionName === 'targeting') {
                Track.userAttributesVisible();
            }
        };

        /**
         * User manually changed the accent color.
         */
        $scope.accentColorSetManually = function () {
            $scope.model.accentColorSetManually = true;

            // The "true" at the end will return the opposite value.
            $scope.model.currentFeedbackWidget.skin = ColorHelper.isDarkOrLight(
                $scope.model.currentFeedbackWidget.background,
                true
            );
        };

        $scope.onAccentColorChange = function (color) {
            $scope.model.currentFeedbackWidget.background = color;

            $scope.accentColorSetManually();
            $scope.reloadPreview();
        };

        $scope.onThemeChange = function (theme) {
            $scope.model.currentFeedbackWidget.skin = theme;
            $scope.reloadPreview();
        };

        $scope.onAccentColorReset = function () {
            $scope.resetAccentColor();
            $scope.reloadPreview();
        };

        /**
         * Reset the accent color of the widget.
         */
        $scope.resetAccentColor = function () {
            $scope.model.accentColorSetManually = false;
            $scope.model.currentFeedbackWidget.background = $scope.model.defaultAccentColor;

            // Reset the skin as well.
            $scope.model.currentFeedbackWidget.skin = angular.copy(DefaultFeedbackData.getData().skin);
        };

        /**
         * Toggle the Hotjar branding on the incoming feedback widget.
         */
        $scope.toggleBranding = function (hideBranding) {
            $scope.model.currentFeedbackWidget.show_branding = !hideBranding;
            setDirtyAndReloadPreview();
        };

        $scope.showUpsellFromAccentColor = function () {
            $scope.showUpsellModal('feedback.appearance.accent_color');
        };

        $scope.showUpsellFromBranding = function () {
            $scope.showUpsellModal('feedback.branding.toggle');
        };

        $scope.showUpsellFromTargetingCap = function () {
            $scope.showUpsellModal('feedback.targeting.cap');
        };

        $scope.onShowUpsellFromPagesTargeting = function () {
            $scope.showUpsellModal('feedback.targeting.triggers');
        };

        $scope.onShowUpsellFromUserAttributes = function () {
            $scope.showUpsellModal('feedback.targeting.attributes');
        };

        /**
         * Toggle the Email field on the incoming feedback widget.
         */
        $scope.toggleEmail = function (newValue) {
            $scope.model.sectionOptions.emailFieldEnabled = newValue;
            if (!$scope.model.sectionOptions.emailFieldEnabled) {
                $scope.model.currentFeedbackWidget.content.email = false;
                $scope.reloadPreview('emotion');
            } else {
                const defaultEmailValid = DefaultFeedbackData.getData().content.email;
                $scope.model.currentFeedbackWidget.content.email = defaultEmailValid;
                $scope.reloadPreview('email');
            }
        };

        /**
         * Toggle the comment footer feature on the incoming feedback widget.
         */
        $scope.toggleCommentFooter = function (newValue) {
            const isCommentFooterEnabled = ($scope.model.sectionOptions.commentFooterEnabled = newValue);
            const commentFooter = DefaultFeedbackData.getData(null, isCommentFooterEnabled).content.comment_footer;

            $scope.model.currentFeedbackWidget.content.comment_footer = commentFooter;
            $scope.reloadPreview(isCommentFooterEnabled ? 'comment' : 'emotion');
        };

        /**
         * Toggle the Email forwarding field on the incoming feedback widget.
         */
        $scope.toggleEmailForwarding = function () {
            if (!$scope.model.sectionOptions.emailForwardingEnabled) {
                $scope.model.forwarding_email_address_list = null;
            }
        };

        function isPageTargetingRule(rule) {
            return rule.component === 'url' || rule.component === 'trigger';
        }

        /**
         * Toggle an entire site targeting rule in the targeting rules.
         */
        $scope.togglePageTargeting = function (targetingType) {
            $scope.model.sectionOptions.activePageTargetingOption = targetingType;

            if (targetingType === 'all') {
                // add the 'all pages' rule
                $scope.model.currentFeedbackWidget.targeting = [
                    ...$scope.model.currentFeedbackWidget.targeting,
                    angular.copy(TargetingRule.ruleObject.url.allPages)
                ];
                return;
            }

            // remove the 'all pages' rule
            $scope.model.currentFeedbackWidget.targeting = $scope.model.currentFeedbackWidget.targeting.filter(
                (rule) => !(rule.component === 'url' && rule.match_operation === 'contains' && rule.pattern === '/')
            );

            // if there are now no existing page targeting rules, add an empty one
            if (!$scope.model.currentFeedbackWidget.targeting.some(isPageTargetingRule)) {
                $scope.model.currentFeedbackWidget.targeting = [
                    ...$scope.model.currentFeedbackWidget.targeting,
                    angular.copy(TargetingRule.ruleObject.url.empty)
                ];
                return;
            }
        };

        $scope.onAddTargetingRule = function (newRule) {
            $scope.model.currentFeedbackWidget.targeting = [...$scope.model.currentFeedbackWidget.targeting, newRule];
        };

        $scope.onChangeTargetingRule = function (rule) {
            const newRulesSet = [...$scope.model.currentFeedbackWidget.targeting];
            newRulesSet[newRulesSet.findIndex((r) => r === rule)] = { ...rule };
            $scope.model.currentFeedbackWidget.targeting = newRulesSet;
        };

        $scope.onRemoveTargetingRule = function (rule) {
            $scope.model.currentFeedbackWidget.targeting = $scope.model.currentFeedbackWidget.targeting.filter(
                (r) => r !== rule
            );
        };

        $scope.onUserTargetingModeChange = function (targetingMode) {
            $scope.model.sectionOptions.activeUserTargetingOption = targetingMode;
        };

        $scope.validateForm = (isValid) => {
            $scope.isQuestionsFormValid = isValid;
        };

        $scope.toggleShowLegal = function (shouldShow) {
            $scope.model.currentFeedbackWidget.show_legal = shouldShow;

            $scope.reloadPreview('thankYou');
        };

        /**
         * Check if the site has the required legal details (legal name and privacy policy link)
         */
        $scope.siteHasLegalDetails = function () {
            return Site.hasLegalDetails();
        };

        /**
         * Gets the current emotionStyle. Uses the seasonal one if set, otherwise the regular.
         */
        $scope.getEmotionStyle = function () {
            let emotionStyle = $scope.model.currentFeedbackWidget.emotion_style,
                seasonalEmotionStyle = $scope.model.currentFeedbackWidget.seasonal_emotion_style || '';
            return seasonalEmotionStyle === '' ? emotionStyle || 'default' : seasonalEmotionStyle;
        };

        /**
         * Set the emotion style.
         */
        $scope.setEmotionStyle = function (emotion) {
            if (emotion.feature === false || $scope.canUseEmotionStyleChoices()) {
                $scope.model.sectionOptions.changedEmotionStyle = true;
                if (emotion.seasonal) {
                    // Since availability is checked when loading themes, we set a wide availability here.
                    $scope.model.currentFeedbackWidget.seasonal_emotion_style = emotion.value;
                    $scope.model.currentFeedbackWidget.active_seasonal_emotion_style = {
                        name: emotion.value,
                        available_from: 1,
                        available_to: 17514144000
                    };
                } else {
                    $scope.model.currentFeedbackWidget.seasonal_emotion_style = '';
                    $scope.model.currentFeedbackWidget.active_seasonal_emotion_style = {};
                    $scope.model.currentFeedbackWidget.emotion_style = emotion.value;
                }

                $scope.reloadPreview('emotion');
            } else {
                $scope.showUpsellModal('feedback.emotion_style_choices');
            }
        };

        $scope.reloadPreview = function (step) {
            // Since we don't show the usual thankYou bubble when asking for consent
            // we switch to the consent step here instead.
            if (step === 'thankYou' && $scope.model.currentFeedbackWidget.connect_visit_data === 'ask') {
                step = 'consent';
            }
            $scope.model.previewConfig = cloneDeep({
                activeSeasonalEmotionStyle: $scope.model.currentFeedbackWidget.active_seasonal_emotion_style,
                activeStepInPreview: step,
                background: $scope.model.currentFeedbackWidget.background,
                connectVisitData: $scope.model.currentFeedbackWidget.connect_visit_data,
                content: $scope.model.currentFeedbackWidget.content,
                displayType: $scope.model.currentFeedbackWidget.display_type,
                parentElementSelector: '#hj-preview-container',
                emotionStyle: $scope.model.currentFeedbackWidget.emotion_style,
                language: $scope.model.currentFeedbackWidget.language,
                legalName: UserData.currentSite.legal_name,
                position: $scope.model.currentFeedbackWidget.position,
                privacyPolicyUrl: UserData.currentSite.privacy_policy_url,
                showBranding: $scope.model.currentFeedbackWidget.show_branding,
                showLegal: $scope.model.currentFeedbackWidget.show_legal,
                skin: $scope.model.currentFeedbackWidget.skin,
                widgetLabel: $scope.model.currentFeedbackWidget.widget_label
            });
        };

        /**
         * Get any limits we have.
         */
        $scope.featureLimits = function () {
            return AskFeature.getLimitsForAsk('feedback', $scope.model.feedbackWidgetsCount);
        };

        /**
         * Return true if the language selected is RTL.
         */
        $scope.isRtlLanguage = function () {
            if ($scope.model.currentFeedbackWidget) {
                return $scope.model.rtlLanguages.indexOf($scope.model.currentFeedbackWidget.language) > -1;
            }
        };

        $scope.updateConnectVisitData = function (shouldConnect) {
            setDirtyAndReloadPreview(() => {
                _.extend($scope.model.currentFeedbackWidget, {
                    connect_visit_data: shouldConnect
                });
            }, 'thankYou');
        };

        $scope.enabledAndValid = ({ enabled, valid } = {}) => enabled && valid;

        $scope.onForwardChanges = function (forwardingSettings) {
            // NOTE: Recreate the object here to trigger re-render of the root React component
            // so webhooks are updated

            if (forwardingSettings.slack) {
                Object.assign($scope.model.forwardingSettings.slack, forwardingSettings.slack);
            } else if (forwardingSettings.email) {
                Object.assign($scope.model.forwardingSettings.email, forwardingSettings.email);
            } else if (forwardingSettings.msTeams) {
                $scope.model.forwardingSettings.msTeams = {
                    ...$scope.model.forwardingSettings.msTeams,
                    ...forwardingSettings.msTeams
                };
            } else if (forwardingSettings.webhooks) {
                $scope.model.forwardingSettings.webhooks = {
                    ...$scope.model.forwardingSettings.webhooks,
                    ...forwardingSettings.webhooks
                };
            }
        };

        $scope.setName = function (newName) {
            $scope.$apply(function () {
                $scope.model.currentFeedbackWidget.name = newName;
            });
        };

        $scope.setDescription = function (newDescription) {
            $scope.$apply(function () {
                $scope.model.currentFeedbackWidget.description = newDescription;
            });
        };

        $scope.onLanguageChanged = (newLanguage) => {
            $scope.$apply(function () {
                $scope.model.currentFeedbackWidget.language = newLanguage;
                $scope.reloadPreview();
            });
        };

        $scope.updatePosition = (position) => {
            $scope.model.currentFeedbackWidget.position = position;
            $scope.reloadPreview();
        };

        $scope.updateParentElementSelector = (parentElementSelector) => {
            $scope.model.currentFeedbackWidget.parent_element_selector = parentElementSelector;
        };

        $scope.onPercentageChanged = (percentage) => {
            $scope.model.currentFeedbackWidget.targeting_percentage = percentage;
        };

        $scope.onInitialMessageChanged = (newMessage) => {
            $scope.model.currentFeedbackWidget.content.initial = newMessage;
            $scope.$digest();
            $scope.reloadPreview('initial');
        };

        $scope.onEmotionMessageChanged = (newMessage) => {
            $scope.model.currentFeedbackWidget.content.emotion = newMessage;
            $scope.$digest();
            $scope.reloadPreview('emotion');
        };

        $scope.onToggleAutoScreenshot = (newValue) => {
            $scope.model.currentFeedbackWidget.auto_screenshot = newValue;
        };

        $scope.onCommentChanged = (newMessage) => {
            $scope.model.currentFeedbackWidget.content.comment_footer = newMessage;
            $scope.reloadPreview('comment');
        };

        $scope.onEmailChanged = (newMessage) => {
            $scope.model.currentFeedbackWidget.content.email = newMessage;
            $scope.$digest();
            $scope.reloadPreview('email');
        };

        $scope.onThankyouChanged = (newMessage) => {
            $scope.model.currentFeedbackWidget.content.thankyou = newMessage;
            $scope.$digest();
            $scope.reloadPreview('thankYou');
        };

        $scope.devices = undefined;

        $scope.$watch('model.currentFeedbackWidget.targeting', () => {
            $scope.devices = $scope.model.currentFeedbackWidget.targeting
                ?.filter((rule) => rule.component === 'device')
                .reduce((previous, current) => [...previous, current.pattern], []);
        });

        $scope.onDevicesChanged = (devices) => {
            const newTargetingRules = [
                ...$scope.model.currentFeedbackWidget.targeting.filter((rule) => rule.component !== 'device'),
                ...devices.map((device) => ({
                    component: 'device',
                    match_operation: 'exact',
                    negate: false,
                    pattern: device
                }))
            ];

            $scope.model.currentFeedbackWidget.targeting = newTargetingRules;
        };

        $scope.onChangeDisplayType = (newDisplayType) => {
            $scope.model.currentFeedbackWidget.display_type = newDisplayType;
            $scope.reloadPreview();
            $scope.$digest();
        };
    }
]);
